export { Text } from "@mantine/core";
export type { TextProps } from "@mantine/core";
export { getTextOverrides } from "./Text.styled";
